import React from "react";
import { graphql, compose } from "react-apollo";
import { withRouter } from "react-router";
import {
  currentUserCart,
  updateNodeCartLineItem,
  currencyById,
  deleteNodeCartLineItem,
  addNotesToCartLineItem,
  currentUserQuery,
  getText,
  getQuantitiesByRegion,
} from "../../queries";
import {
  CartItem,
  PageHeader,
  CartToolbar,
  Modal,
  Message,
  Button,
  Spinner,
} from "dab-component-lib";
import axios from "axios";
import _ from "lodash";
import { REMOVE_ELEMENT, GETPDF, API_HOST } from "../../utils/constants";
import I18n from "../../I18n/I18n";

import {
  CartItemWrapper,
  CartToolbarWrapperStyle,
  PdfButtonContainerStyle,
} from "./style";
import {
  GridContainerStyle,
  PageHeaderWrapperStyle,
  LoadingStyle,
  ErrorStyle,
} from "../../utils/style-utils";
import { getTotalByRegion } from "../../utils";

class Checkout extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      showRemoveModal: false,
      removeId: "",
      loadingReset: false,
    };
  }
  
  updateProductQuantity = async (id, nid, quantity) => {
    const { updateNodeCartLineItem, currentUserCart } = this.props;
    await updateNodeCartLineItem({
      variables: {
        id,
        nid,
        quantity,
      },
    });
    currentUserCart.refetch({
      id: localStorage.getItem("currentUid"),
    });
  };
  
  addNotes = async (id, note) => {
    const { addNotesToCartLineItem, currentUserCart } = this.props;
    await addNotesToCartLineItem({
      variables: {
        id,
        note,
      },
    });
    currentUserCart.refetch({
      id: localStorage.getItem("currentUid"),
    });
  };
  
  showRemove = (id) => {
    this.setState({
      removeId: id,
      showRemoveModal: !this.state.showRemoveModal,
    });
  };
  
  deleteRow = async () => {
    const {
      currentUserCart: { loading, error, currentusercartGraphql1View },
    } = this.props;
    this.setState({ showRemoveModal: false });
    let id = this.state.removeId;
    let uid = localStorage.getItem("currentUid");
    if (!loading && !error) {
      let cart_id = currentusercartGraphql1View.results[0].id;
      await axios.get(`${REMOVE_ELEMENT}/${cart_id}/${id}/${uid}`);
      this.props.currentUserCart.refetch();
    }
  };
  
  resetCart = async (i = 0) => {
    const {
      currentUserCart: { loading, error, currentusercartGraphql1View, refetch },
      history,
    } = this.props;
    this.setState({ loadingReset: true });
    let uid = localStorage.getItem("currentUid");
    if (!loading && !error && currentusercartGraphql1View.results.length > 0) {
      let cart_id = currentusercartGraphql1View.results[0].id;
      currentusercartGraphql1View.results[0].fieldLineItemsReference.forEach(
        async (item) => {
          let id = item.targetId;
          await axios.get(`${REMOVE_ELEMENT}/${cart_id}/${id}/${uid}`);
          i++;
          await this.resetCart();
        }
      );
    }
    await refetch();
    i--;
    if (i === 0) {
      history.push("/");
    }
  };
  
  getPDF = () => {
    const {
      currentUserCart: { loading, error, currentusercartGraphql1View },
    } = this.props;
    let uid = localStorage.getItem("currentUid");
    if (!loading && !error) {
      let cart_id = currentusercartGraphql1View.results[0].id;
      axios
        .get(
          `${GETPDF}/${cart_id}/${uid}/${
            localStorage.getItem("showPrices") ? 1 : 0
          }/${
            localStorage.getItem("language")
              ? localStorage.getItem("language")
              : "it"
          }/${
            localStorage.getItem("currency")
              ? localStorage.getItem("currency")
              : localStorage.getItem("defaultCurrency")
          }`
        )
        .then((response) => window.open(`${API_HOST}${response.data.url}`))
        .catch((e) => console.log(e));
    }
  };
  
  render() {
    const {
      history,
      currentUserCart: { loading, error, currentusercartGraphql1View },
      currencyById,
      currentUserQuery,
      getText,
      getTextModal,
      getQuantitiesByRegion,
    } = this.props;
    const { loadingReset } = this.state;
    
    let sumPrices = 0;
    
    const canBuy = () => {
      let itemsWithRequiredNotes = currentusercartGraphql1View.results.length
        ? currentusercartGraphql1View.results[0].fieldLineItemsReference.filter(
            (x) => x.entity.fieldProductReference.entity.fieldMandatoryNote
          )
        : [];
      let itemsWithNote = itemsWithRequiredNotes.filter(
        (x) =>
          x.entity.fieldLineItemNotes &&
          x.entity.fieldLineItemNotes.trim() !== ""
      );
      return itemsWithRequiredNotes.length === itemsWithNote.length;
    };

    let currencySign = null;

    if (
      loading ||
      loadingReset ||
      getText.loading ||
      getTextModal.loading ||
      currentUserQuery.loading ||
      getQuantitiesByRegion.loading
    ) {
      return (
        <LoadingStyle>
          <Spinner size={150} />
        </LoadingStyle>
      );
    }
    if (
      error ||
      getText.error ||
      getTextModal.error ||
      currentUserQuery.error ||
      getQuantitiesByRegion.error
    ) {
      return (
        <ErrorStyle>
          <h3>{I18n.t("errors.cartError")}</h3>
        </ErrorStyle>
      );
    }
    return (
      <div>
        {!loading &&
          !error &&
          !currencyById.error &&
          !currencyById.loading &&
          !getText.loading &&
          !getText.error &&
          !getTextModal.loading &&
          !getTextModal.error &&
          !currentUserQuery.loading &&
          !currentUserQuery.error &&
          !getQuantitiesByRegion.loading &&
          !getQuantitiesByRegion.error && (
            <div>
              <GridContainerStyle>
                <Modal
                  handleClose={() => this.showRemove("")}
                  open={this.state.showRemoveModal}
                >
                  <Message
                    action={{
                      label: I18n.t("buttons.deleteProduct"),
                      onClick: () => this.deleteRow(),
                    }}
                    actionSecondary={{
                      label: I18n.t("buttons.cancel"),
                      onClick: () => this.showRemove(""),
                      outline: true,
                    }}
                    title={
                      getTextModal.translationMetadataGraphql1View.results
                        .length > 0 &&
                      getTextModal.translationMetadataGraphql1View.results[0]
                        .fieldMainText
                    }
                    description={
                      getTextModal.translationMetadataGraphql1View.results
                        .length > 0 &&
                      getTextModal.translationMetadataGraphql1View.results[0]
                        .fieldSubText
                    }
                  />
                </Modal>
                <PageHeaderWrapperStyle>
                  <PageHeader
                    title={
                      getText.translationMetadataGraphql1View.results.length >
                        0 &&
                      getText.translationMetadataGraphql1View.results[0]
                        .fieldMainText
                    }
                    description={
                      getText.translationMetadataGraphql1View.results.length >
                        0 &&
                      getText.translationMetadataGraphql1View.results[0]
                        .fieldSubText
                    }
                  />
                </PageHeaderWrapperStyle>
                {currentusercartGraphql1View.results.length > 0
                  ? currentusercartGraphql1View.results[0].fieldLineItemsReference.map(
                      (item) => {
                        let product = item.entity.fieldProductReference.entity;
                        let productId =
                          item.entity.fieldProductReference.targetId;
                        let quantity =
                          item.entity.fieldProductReference.quantity;
                        let price = {};
                        if (!currencyById.error && !currencyById.loading) {
                          let currencyName =
                            currencyById.nodeById.fieldCurrencyName;
                          currencySign =
                            currencyById.nodeById.fieldCurrencySign;
                          price = _.find(
                            product.fieldPrices,
                            (price) =>
                              price.entity.fieldCurrency ===
                              (currencyName ? currencyName : "EUR")
                          );
                        }
                        sumPrices += price.entity.fieldPriceAmount * quantity;
                        return (
                          <CartItemWrapper key={item.targetId}>
                            <CartItem
                              availability={
                                product.fieldAvailability >= 0
                                  ? getTotalByRegion(
                                      item.targetId.toString(),
                                      currentUserQuery.currentUserContext
                                        .fieldRegion,
                                      getQuantitiesByRegion
                                        .filteredProductsGraphqlAmountxRegionView
                                        .results
                                    )
                                  : 0
                              }
                              currency={currencySign}
                              handleQuantityChange={(props) =>
                                this.updateProductQuantity(
                                  item.targetId.toString(),
                                  productId,
                                  props.quantity
                                )
                              }
                              handleRemoveFromCart={() =>
                                this.showRemove(item.targetId)
                              }
                              handleSaveNote={({ note }) =>
                                this.addNotes(item.targetId.toString(), note)
                              }
                              id={item.targetId.toString()}
                              lang={
                                localStorage.getItem("language")
                                  ? localStorage.getItem("language")
                                  : "it"
                              }
                              maxQuantity={
                                item.entity.fieldProductReference.entity
                                  .fieldMaxShopQuantity
                              }
                              name={product.name}
                              note={item.entity.fieldLineItemNotes}
                              photoUrl={
                                product.fieldProductImages.length > 0
                                  ? product.fieldProductImages[0].url
                                  : ""
                              }
                              price={parseFloat(
                                price.entity.fieldPriceAmount * quantity
                              ).toFixed(2)}
                              productId={product.fieldCode}
                              requiredNotes={
                                item.entity.fieldProductReference.entity
                                  .fieldMandatoryNote
                              }
                              quantity={quantity}
                              showPrice={
                                localStorage.getItem("showPrices") === "true" &&
                                !_.find(
                                  currentUserQuery.currentUserContext.roles,
                                  (role) => role.targetId === "visitor_customer"
                                )
                              }
                              size=""
                            />
                          </CartItemWrapper>
                        );
                      }
                    )
                  : null}
              </GridContainerStyle>
              {!_.find(
                currentUserQuery.currentUserContext.roles,
                (role) =>
                  role.targetId === "visitor_customer" ||
                  role.targetId === "visitor_filial"
              ) && (
                <CartToolbarWrapperStyle isDisabled={!canBuy()}>
                  <CartToolbar
                    lang={
                      localStorage.getItem("language")
                        ? localStorage.getItem("language")
                        : "it"
                    }
                    currency={currencySign}
                    handleCheckout={() => history.push("/order-details")}
                    totalItems={
                      currentusercartGraphql1View.results[0]
                        .fieldLineItemsReference.length
                    }
                    totalPrice={
                      localStorage.getItem("showPrices") === "true"
                        ? parseFloat(sumPrices).toFixed(2)
                        : "- "
                    }
                  />
                </CartToolbarWrapperStyle>
              )}
              {_.find(
                currentUserQuery.currentUserContext.roles,
                (role) =>
                  role.targetId === "visitor_customer" ||
                  role.targetId === "visitor_filial"
              ) && (
                <PdfButtonContainerStyle>
                  <Button
                    icon={null}
                    iconOrientation="top"
                    id="reset_cart"
                    label={I18n.t("buttons.resetCart")}
                    onClick={() => this.resetCart()}
                    outline
                    size="S"
                  />
                  <Button
                    icon={null}
                    iconOrientation="top"
                    id="get_pdf"
                    label={I18n.t("buttons.getPdf")}
                    onClick={() => this.getPDF()}
                    size="S"
                  />
                </PdfButtonContainerStyle>
              )}
            </div>
          )}
      </div>
    );
  }
}

export default compose(
  graphql(currentUserQuery, {
    name: "currentUserQuery",
  }),
  graphql(currentUserCart, {
    name: "currentUserCart",
    options: () => ({
      variables: {
        id: localStorage.getItem("currentUid"),
        lang: localStorage.getItem("language")
          ? localStorage.getItem("language")
          : "it",
      },
    }),
  }),
  graphql(getQuantitiesByRegion, {
    name: "getQuantitiesByRegion",
    options: () => ({
      variables: {
        field_product_category_target_id: null,
        id: null,
        name: localStorage.getItem("userRegion")
          ? localStorage.getItem("userRegion")
          : "ITALY",
      },
    }),
  }),
  graphql(updateNodeCartLineItem, {
    name: "updateNodeCartLineItem",
  }),
  graphql(currencyById, {
    name: "currencyById",
    options: () => ({
      variables: {
        id: localStorage.getItem("currency")
          ? localStorage.getItem("currency")
          : localStorage.getItem("defaultCurrency"),
      },
    }),
  }),
  graphql(deleteNodeCartLineItem, {
    name: "deleteNodeCartLineItem",
  }),
  graphql(addNotesToCartLineItem, {
    name: "addNotesToCartLineItem",
  }),
  graphql(getText, {
    name: "getText",
    options: () => ({
      variables: {
        machineName: "checkout",
        lang: localStorage.getItem("language")
          ? localStorage.getItem("language")
          : "it",
      },
    }),
  }),
  graphql(getText, {
    name: "getTextModal",
    options: (props) => ({
      variables: {
        machineName: "checkout_remove_modal",
        lang: localStorage.getItem("language")
          ? localStorage.getItem("language")
          : "it",
      },
    }),
  })
)(withRouter(Checkout));



// WEBPACK FOOTER //
// ./src/components/checkout/index.js